import React from 'react';
import SamplesFlow, { SingleSampleFlowProps } from 'cards/components/common/Samples/SamplesFlow';

import styles from './styles.module.less';

const SamplesModal = ({
  cardNameList,
  cardSuiteUUIDList,
  cardUUIDList,
  entryPoint,
  flowName,
  isMagnet,
  selectedColorSet,
  reopenCurrentModal,
  setModalOptions,
}: SingleSampleFlowProps): JSX.Element => (
  <SamplesFlow
    cardNameList={cardNameList}
    cardSuiteUUIDList={cardSuiteUUIDList}
    cardUUIDList={cardUUIDList}
    entryPoint={entryPoint}
    flowName={flowName}
    isMagnet={isMagnet}
    selectedColorSet={selectedColorSet}
    reopenCurrentModal={reopenCurrentModal}
    setModalOptions={setModalOptions}
  />
);

export default {
  component: SamplesModal,
  className: styles.samplesModal,
  options: {
    bottomModalOnMobile: true,
    warnOnClose: true,
  },
};
